// extracted by mini-css-extract-plugin
module.exports = {"Dashboard":"Dashboard_Dashboard__2kB1y"};